import React from 'react';
import moment from 'moment';
import { IconComponent } from '../atoms/icons/iconComponent';

const Timeline = ({ className, list }) => {
  const date = [...list];
  const statusClass = (status) => {
    switch (status) {
      case 'done':
        return 'bg-status-gray';
      case 'warning':
        return 'bg-status-orange';
      case 'danger':
        return 'bg-status-red';
      default:
        return 'bg-primary';
    }
  };
    // TODO: DURATION has to be in relationship between today and checkin
    // if purchase vs checkin is more than 25% of the total
    // keep in mind time-space is calculated in % from day 1 to hotel checkin
  const duration = (dateInitial, dateFinal) => {
    const init = moment(dateInitial);
    const final = moment(dateFinal);
    const durationBetween = moment.duration(final.diff(init));
    return durationBetween.asDays();
  };
  const initialDate = date.shift().date;
  const finalDate = date.pop().date;
  const maxDiff = duration(initialDate, finalDate);
  const setScaleDates = () => list.map((mark) => {
    const scale = duration(initialDate, mark.date) / maxDiff;
    return Object.assign(mark, { scale });
  });
  setScaleDates();

  const isTodayClass = (id) => {
    switch (id) {
      case 'today':
        return 'font-bold text-sm';
      case 'checkIn':
      case 'purchase':
        return 'text-xs';
      default:
        return 'hidden';
    }
  };
  const TimelineDesktop = (mark, index) => (
    <div
      key={index}
      // mt-10 and mb-4 exists in order to keep spacing to the absolute elements,
      // h-2 is the hegight of the bar
      className={`pointer absolute z-1 hover:z-10 inset-x-0 h-2 group ${statusClass(
        mark.status,
      )} mb-8`}
      style={{ width: `${mark.scale * 100}%` }}
    >
      <IconComponent
        icon={mark.icon}
        className="absolute text-primary top-1 -mr-2 right-0 transform -translate-y-1/2"
      />

      <div className="hidden md:block">
        <div className={`absolute hover:z-10 group-hover:z-10 bg-white py-1 px-2 
        right-0 bottom-3 transform translate-x-1/2 ${isTodayClass(mark.id)}`}>
          {mark.title}
        </div>
        {/* <div className="absolute top-4 right-0 max-w-24 text-center py-1 px-2 transform translate-x-1/2 text-primary -z-1 whitespace-nowrap">
          {mark.date}
        </div> */}
        {mark && (
        /* eslint-disable max-len */
          <div className="transition duration-300 opacity-0 group-hover:opacity-100 absolute top-4 right-0 max-w-xxs py-1 px-2 transform translate-x-1/2 bg-white border border-primary">

            <div className="text-xs text-primary-700 text-left">{mark.title}</div>
            <p className="min-w-20">{mark.tooltip || mark.date}</p>
          </div>
          /* eslint-enable max-len */
        )}
      </div>
    </div>
  );
  const TimelineMobile = (mark, index) => (
    <div key={index} className="mb-2">
      <div className="text-primary flex items-center">
        <div className={`h-2 w-2 rounded-full ${statusClass(mark.status)}`} />
        <strong className="mx-1">{mark.title}</strong>
        <span >{mark.date}</span>
      </div>
      <p className="text-gray-500">{mark.tooltip}</p>
    </div>
  );
  return (
    <div className={`${className || ''} relative pt-20 pb-16 mx-2`}>
      {list.reverse().map((el, index) => TimelineDesktop(el, index))}
      <div className="pt-8 flex flex-col md:hidden">
        {list.reverse().map((el, index) => TimelineMobile(el, index))}
      </div>
    </div>
  );
};

export default Timeline;
